import { createReducer, on } from '@ngrx/store';
import { EStateStatus } from '@app/app.state';
import { UserActions } from './user.actions';
import { IUser } from '@core/interfaces/user';
export interface IUserState {
  id: string | null;
  user: IUser | null;
  hasChanges: boolean;
  status: EStateStatus;
  error: string | null;
}
export const initialState: IUserState = {
  id: null,
  user: null,
  hasChanges: false,
  status: EStateStatus.PENDING,
  error: null,
};
export const UserReducer = createReducer(
  initialState,
  on(UserActions.selectUser, (_, { id }) => ({ ...initialState, id })),
  on(UserActions.clearUser, () => initialState),
  on(UserActions.requestUserInfo, (state) => ({
    ...state,
    status: EStateStatus.LOADING,
    error: null,
  })),
  on(UserActions.requestUserInfoSuccess, (state, { id, user }) =>
    state.id === id
      ? { ...state, user, status: EStateStatus.SUCCESS, hasChanges: false }
      : state,
  ),
  on(UserActions.requestUserInfoError, (state, { id, error }) =>
    state.id === id ? { ...state, error, status: EStateStatus.ERROR } : state,
  ),
  on(UserActions.save, (state) => ({
    ...state,
    status: EStateStatus.LOADING,
    error: null,
  })),
  on(UserActions.commandStarted, (state) => ({
    ...state,
    status: EStateStatus.LOADING,
  })),
  on(UserActions.commandFinished, (state) => ({
    ...state,
    status: EStateStatus.SUCCESS,
  })),
  on(UserActions.saved, (state, { id }) => ({
    ...state,
    id,
    status: EStateStatus.SUCCESS,
    hasChanges: false,
  })),
  on(UserActions.failed, (state, { error }) => ({
    ...state,
    status: EStateStatus.ERROR,
    error,
  })),
  on(UserActions.setFormValues, (state, { hasChanges }) => ({
    ...state,
    hasChanges,
  })),
);
